"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";
import { Search } from "lucide-react";

const NotFound = () => {
  const [query, setQuery] = useState("");
  const router = useRouter();

  const handleSearch = (e) => {
    if (e.key === "Enter" && query.trim()) {
      router.push(`/search?s=${encodeURIComponent(query)}`);
    }
  };

  return (
    <div className="min-h-screen mt-20 lg:mt-0">
      {/* Top breadcrumb */}
      <div className="max-w-7xl mx-auto px-4 pt-6 text-sm text-gray-500">
        Home / <span className="text-gray-400">404 Error: page not found</span>
      </div>

      {/* Title */}
      <div className="max-w-7xl mx-auto px-4 mt-4">
        <h1 className="text-2xl font-semibold text-black">Page Not Found</h1>
      </div>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-4 mt-4">
        <div className="border-t border-gray-300"></div>
      </div>

      {/* Search box center */}
      <div className="flex justify-center items-center mt-24">
        <div className="w-full max-w-xl relative">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleSearch}
            placeholder="Type & hit enter"
            className="w-full bg-[#EAEAEA] text-gray-700 px-4 py-3 pr-10 rounded-sm outline-none text-sm"
          />

          {/* Search icon */}
          <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600">
            <Search className="w-4 h-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
